import React from "react";
import { useTranslation } from "react-i18next";

import { Button, Form, Input, Select } from "antd";

import { API_URL } from "../../shared/utils/Util";
import { fetchT } from "../../shared/utils/TypedUtil";
import { useNotification } from "../../shared/hooks";
import { CreateTableRequest, CreateTableResponse } from "../../types/api";

type NewTableFormProps = {
  restaurantId: string;
  onSuccess: () => void;
};

export const NewTableForm = (props: NewTableFormProps) => {
  const { t } = useTranslation();
  const { notifyError, showSuccess } = useNotification();
  const [saveLoading, setSaveLoading] = React.useState(false);
  const [form] = Form.useForm();

  const handleSave = (req: CreateTableRequest) => {
    setSaveLoading(true);

    fetchT<CreateTableResponse>(
      "POST",
      `${API_URL}/v1/r/${props.restaurantId}/tables`,
      req,
      (result: CreateTableResponse) => {
        showSuccess(t("added_new_table_successfully"));
        form.resetFields();
        setSaveLoading(false);
        props.onSuccess();
      },
      (err: any) => {
        setSaveLoading(false);
        notifyError(t("unable_to_add_table"), err);
      }
    );
  };

  return (
    <Form
      form={form}
      initialValues={{
        name: "",
        pos_order_type: "Here",
      }}
      labelCol={{ span: 10 }}
      labelAlign="left"
      wrapperCol={{ span: 16 }}
      layout="horizontal"
      colon={false}
      onFinish={handleSave}
    >
      <Form.Item
        label={t("name")}
        name="name"
        rules={[
          {
            required: true,
            message: t("name_is_required"),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={t("order_type")}
        name="pos_order_type"
        rules={[
          {
            required: true,
            message: t("order_type_is_required"),
          },
        ]}
      >
        <Select
          options={[
            { value: "Here", label: t("dine_in") },
            { value: "ToGo", label: t("to_go") },
          ]}
        />
      </Form.Item>
      <Form.Item>
        <Button type="primary" block htmlType="submit" loading={saveLoading} disabled={saveLoading}>
          {t("save")}
        </Button>
      </Form.Item>
    </Form>
  );
};
